// extracted by mini-css-extract-plugin
export default {"base":"j9cE8","cell":"Kklst","label":"HBgsu","subLabel":"aJAVe","selected":"o2bS1","wide":"T5MTT","disabled":"EWps1"};